<template>
    <div>
        <div
            :class="[
                hasError(errors, 'billing_address_id')
                    ? 'border-red-600'
                    : 'border-gray-200',
                'overflow-hidden bg-white shadow rounded-lg border',
            ]"
        >
            <div
                :class="[
                    hasError(errors, 'billing_address_id')
                        ? 'bg-red-500 text-white border-red-600'
                        : 'bg-gray-100 text-gray-800 border-gray-200',
                    'flex items-center px-4 py-5 sm:px-6 border-b',
                ]"
            >
                <CreditCardIcon class="h-5 w-5 mr-2" aria-hidden="true" />
                <h2 class="font-bold">Payment Method</h2>
            </div>

            <div class="px-4 py-3 sm:px-6">
                <div>
                    <div class="py-3 flex text-gray-700">
                        <UserIcon
                            class="h-5 w-5 mr-2 shrink-0"
                            aria-hidden="true"
                        />

                        <div>
                            <p>
                                {{ name }}
                            </p>
                        </div>
                    </div>

                    <div class="py-3 flex text-gray-700">
                        <CreditCardIcon
                            class="h-5 w-5 mr-2 shrink-0"
                            aria-hidden="true"
                        />

                        <div class="flex items-center">
                            <div class="mr-3">
                                <PaymentMethodIcon
                                    alt="Paypal"
                                    brand="paypal"
                                    class="w-20 h-auto shadow rounded-md"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <button
                    @click="changePaymentMethod"
                    name="change_payment_method"
                    :class="[
                        hasError(errors, 'billing_address_id')
                            ? 'text-red-900 border-red-600 shadow-lg'
                            : 'text-gray-700 border-gray-300 shadow-sm',
                        'w-full inline-flex justify-center items-center px-6 py-3 my-3 border text-base font-medium rounded-md bg-white hover:bg-gray-50 focus:outline-none',
                    ]"
                >
                    <PencilAltIcon class="h-5 w-5 mr-2" aria-hidden="true" />
                    Change Payment
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { CreditCardIcon, PencilAltIcon, UserIcon } from "@heroicons/vue/solid";
import PaymentMethodIcon from "../paymentMethods/PaymentMethodIcon.vue";
import { useForm } from "../../functions/useForm";

defineProps<{
    amount?: number;
    csrf?: string;
    errors?: any;
    name?: string;
}>();

const { hasError } = useForm();

function changePaymentMethod() {
    window.location.href = "/cart";
}
</script>
